<div class="order-details-container">
  <h5 class="title">{{ "modeso_payment_checkout-payment-options_payment-options-caption" | injectedText | async }} </h5>
  <span>
    <label class="icon">
      <img src="assets/lidl-lib-payment-fe/{{ paymentOption?.paymentId | lowercase }}.svg">
    </label>
    <label id="paymentSelected">{{ paymentOption?.paymentName }}</label>
  </span>
</div>
